'use client';

import NumberFlow from '@number-flow/react';
import { useLocale } from 'next-intl';
import type { Format } from 'number-flow/lite';
import { ComponentPropsWithoutRef } from 'react';

type AnimatedNumberProps = {
    value: number;
    className?: string;
    format?: Format;
} & Omit<ComponentPropsWithoutRef<typeof NumberFlow>, 'value' | 'locales' | 'format'>;

export const AnimatedNumber = ({ value, className, format, ...props }: AnimatedNumberProps) => {
    const locale = useLocale();

    return (
        <NumberFlow
            value={value}
            locales={locale}
            format={format}
            className={className}
            transformTiming={{ duration: 100, easing: 'ease' }}
            spinTiming={{ duration: 200, easing: 'ease' }}
            opacityTiming={{ duration: 350, easing: 'ease' }}
            {...props}
        />
    );
};
